import React from 'react';
import { connect } from "react-redux";
import Loader from '../Global/loader.js';
import './main.css';
import jwt from 'jsonwebtoken'
import clientLogin from './../API/Client/Login'
import clientDevices from './../API/Client/GetDevices'
import clientBusinessPremises from './../API/Client/BusinessPremises'
import logout from './../Global/logout';
import Logo from './../images/Login-Logo.png';
import clientInfo from './../API/Client/GetClientInfo'

export class Login extends React.Component{

    state={
        error: false,
        signin: false,
        username: "",
        password: "",
        domain: "",
    }

    constructor(props) {
        super(props);
        document.title = 'Login';
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);        
    }


    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }



    handleSubmit= async (e) => {
        e.preventDefault()
        this.setState({ signin: true })

        const login = await clientLogin(this.state.username,this.state.password, this.state.domain, "client")
        if(login.error){
            this.setState({ error: login.error.response.data.responseMessage });            
        } 
        else{

            this.props.mapState("USER_MAP_CREDENTIALS", this.state.username)
            const token =jwt.sign({
                exp: Math.floor(Date.now() / 1000) +(60 * 30), // 30 min token
                data: login.data.token,
                role: "client"
              }, process.env.REACT_APP_JWT_SALT);


            sessionStorage.setItem("token", token)
            this.props.mapState("USER_MAP_JWT",token)

            //get devices
            const devices = await clientDevices()
            if(devices.error){
               await logout()
            }
            else{
                this.props.mapState("CLIENT_MAP_DEVICES", devices)
            }

            const businesssPremises = await clientBusinessPremises()
            if(businesssPremises.error){
               await logout()
            }
            else{
                this.props.mapState("CLIENT_MAP_BUSSINES_PREMISES", businesssPremises)
            }

            const clientCredentials = await clientInfo()
            if(clientCredentials.error){
                await logout()
            }
            else{               
                this.props.mapState("USER_MAP_CREDENTIALS", clientCredentials.data)
            }
            
            this.props.mapState("USER_LOG_IN")
            this.props.history.replace("/Client/dashboard/")
        }

        this.setState({ signin: false })
       
    }  

    componentDidMount(){    
        if (sessionStorage.getItem("token") !== null) {
            this.props.history.replace("/Client/dashboard/")
            //window.location= "/dashboard/"            
        }       
    }
    
    render(){  
        const {signin, error} = this.state       

    return(
        
        <main className="admin_login" role="main">
                {signin ?
                    <Loader/>                                   
                :               
                
                    /*!this.props.userLoggedIn ?*/
                    <div className="login" style={{position: "absolute"}}> 
                        <img src={Logo} alt="logo" style={{width: "inherit", marginBottom: "20px"}}/>
                        <form className="form-signin">
                        
                                <input 
                                    type="text" 
                                    id="username" 
                                    name="username" 
                                    placeholder="Korisničko ime" 
                                    defaultValue={this.state.username} 
                                    onChange={this.handleChange} 
                                />
                        
                                <input 
                                    type="password" 
                                    placeholder="Lozinka" 
                                    defaultValue={this.state.password} 
                                    onChange={this.handleChange}
                                    id="password" 
                                    name="password"                                 
                                />

                                <input 
                                    type="text" 
                                    placeholder="Domena" 
                                    defaultValue={this.state.domain} 
                                    onChange={this.handleChange}
                                    id="domain" 
                                    name="domain"                                 
                                />
                            
                            { error ? 
                                <p className="error-color" style={{color: "red", fontSize: "20px"}}>{error}</p>
                            : null }
                            <br />         
                            <button 
                                className="btn btn-lg btn-primary btn-block"                                 
                                onClick={(e) =>this.handleSubmit(e)}
                                style={{fontSize: "20px"}}
                            > 
                                Prijava
                            </button>
                        </form>
                    </div>
                                        
                }   
        </main>
    )
    }  
}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.client.userLoggedIn,
        authError: state.client.authError,
        jwtToken: state.client.jwtToken
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Login);
